import React from "react";
import classNames from "classnames";

class Hamburger extends React.PureComponent {
  render() {
    const { className, isActive, ...rest } = this.props;
    const buttonClasses = classNames(
      "hamburger",
      "hamburger--collapse",
      { "is-active": isActive },
      className,
    );
    
    return (
      <div className={ buttonClasses } { ...rest }>
        <span className="hamburger-box">
          <span className="hamburger-inner"/>
        </span>
      </div>
    );
  }
}

export default Hamburger;



// WEBPACK FOOTER //
// ./app/components/Hamburger/Hamburger.jsx